import { jsxs as c, jsx as n } from "react/jsx-runtime";
import { memo as C, useMemo as f } from "react";
import { useTranslation as I } from "react-i18next";
import { useCreditLimits as L, useCreditUtils as w, CREDIT_LIMITS_FORM_FIELDS as s, CreditType as N } from "@perxis-auto/credit-sdk";
import { Form as O, Row as P, Col as o, Typography as p, Slider as z } from "@perxis-auto/ui-kit";
import { APP as A } from "../../../shared/config/app.js";
import { SliderField as b } from "../../SliderField/ui/SliderField.js";
const { useWatch: h, useFormInstance: R } = O, H = C(function({ formatters: d }) {
  const { t: l } = I(A.name), u = R(), { data: e, isLoading: t } = L(), {
    normalizers: { downPaymentNormalize: y, residualPaymentNormalize: g },
    formatters: { periodTipFormatter: m }
  } = w({ form: u }), F = f(() => e != null && e.numberOfPeriods ? e.numberOfPeriods.reduce((i, r) => r === e.numberOfPeriods[0] ? {
    ...i,
    [r]: {
      style: {
        transform: "translateX(0)"
      },
      label: r
    }
  } : r === e.numberOfPeriods[e.numberOfPeriods.length - 1] ? {
    ...i,
    [r]: {
      style: {
        transform: "translateX(-100%)"
      },
      label: r
    }
  } : r !== e.numberOfPeriods.length ? {
    ...i,
    [r]: r
  } : {
    ...i,
    [r]: {
      style: {
        color: "var(--perxis-auto-root-second-color-inner)",
        fontWeight: 400
      },
      label: r
    }
  }, {}) : void 0, [e == null ? void 0 : e.numberOfPeriods]), x = f(() => {
    if (!(!(e != null && e.numberOfPeriods) || !(e != null && e.numberOfPeriods.length)))
      return e.numberOfPeriods[0];
  }, [e == null ? void 0 : e.numberOfPeriods]), T = f(() => {
    if (!(!(e != null && e.numberOfPeriods) || !(e != null && e.numberOfPeriods.length)))
      return e.numberOfPeriods[e.numberOfPeriods.length - 1];
  }, [e == null ? void 0 : e.numberOfPeriods]), M = h(s.type, u), a = h(s.numberOfPeriods, u), v = M !== N.RESIDUAL_PAYMENT;
  return /* @__PURE__ */ c(P, { gutter: [0, "vertical-green"], children: [
    /* @__PURE__ */ n(o, { span: 24, children: /* @__PURE__ */ n(
      b,
      {
        formatters: d,
        label: l("sliders.downPayment"),
        inputField: s.downPaymentAmount,
        sliderField: s.downPayment,
        sliderFieldProps: {
          normalize: y
        },
        disabled: t
      }
    ) }),
    !v && /* @__PURE__ */ n(o, { span: 24, children: /* @__PURE__ */ n(
      b,
      {
        formatters: d,
        label: l("sliders.residualPayment"),
        inputField: s.residualPaymentAmount,
        sliderField: s.residualPayment,
        sliderFieldProps: {
          normalize: g
        },
        disabled: t
      }
    ) }),
    /* @__PURE__ */ n(o, { span: 24, children: /* @__PURE__ */ c(P, { className: "perxis-auto-credit-calc-slider", gutter: [0, "vertical-purple"], children: [
      /* @__PURE__ */ n(o, { span: 24, children: /* @__PURE__ */ c(P, { justify: "space-between", align: "middle", gutter: [0, "vertical-purple"], children: [
        /* @__PURE__ */ n(p.Text, { className: "perxis-auto-credit-calc-slider-label", level: "main", children: l("sliders.creditTerm") }),
        /* @__PURE__ */ n(p.Text, { className: "perxis-auto-credit-calc-slider-value", level: "h4", children: d && d.period ? `${m(a)} ${d.period(m(a))}` : m(a) })
      ] }) }),
      /* @__PURE__ */ n(o, { span: 24, children: /* @__PURE__ */ n(O.Item, { name: s.numberOfPeriods, children: /* @__PURE__ */ n(
        z,
        {
          min: x,
          max: T,
          marks: F,
          valueVisible: !1,
          step: null,
          disabled: t
        }
      ) }) })
    ] }) })
  ] });
});
export {
  H as FormControls
};
